import React from "react";
import { List as OffersListing} from "./../components/offer";
import { List as PreoffersListing} from "./../components/preoffer";
import { Layouts } from "../components";
import { CompanyContext } from "../contexts/CompanyContext";

import "./OfferingsList.scss";

function OfferingsList() {
  const { selectedCompany } = React.useContext(CompanyContext);

  return (
    <>
      <Layouts.PageHeader
        left={`Offers for ${selectedCompany.name}`}
      />
      <div className="px-3">
        <Layouts.OverviewSubheader left="Pre-Launches" tooltipDesc="Pre-launch lets companies gauge investor interest prior to completing the legal compliance work to do a fundraise. Indicating interest is non-binding, which means no money from subscribers is sent to your company." />
        <PreoffersListing companyId={selectedCompany.slug} />
        <Layouts.OverviewSubheader left="Offerings" tooltipDesc="Offerings are full fundraising efforts. All information related to each of your offers can be accessed by clicking the offer rows below." />
        <OffersListing companyId={selectedCompany.slug} />
      </div>
    </>
  );
}

OfferingsList.defaultProps = {};

OfferingsList.propTypes = {};

export default OfferingsList;